import { getReporting } from "@/config/reporting.config";

export const report = getReporting();
/**
 * 进入官网
 */
export const homeOnShowReporting = () => {
  report.track("web_enter_1", {});
};

// 进入概念站
export const homeOnOfficialSiteClickReporting = () => {
  report.track("worldweb_enter_1", {});
};

// 点击点击适龄提示
export const homeOnAgeTipsClickReporting = () => {
  report.track("Age_appropriate_1", {});
};

//点击选择登录渠道
export const clickLogin = (login_channel) => {
  report.track("Login_step1_1", { login_channel });
};

// 完成登录
export const homeOnOfficialMediaCompleteReporting = (login_channel) => {
  report.track("Login_finish_1", { login_channel });
};

// 点击立即预约
export const homeOnOfficialMediaAppointClickReporting = () => {
  report.track("booking_step1_1", {});
};

// 提交预约
export const homeOnOfficialMediaAppointCompleteReporting = () => {
  report.track("booking_step2_1", {});
};

// 预约成功
export const homeOnOfficialMediaAppointSuccessReporting = (share_plat) => {
  report.track("booking_finish_1", { share_plat });
};

// 点击进入新闻详情页
export const homeOnOfficialNewsClickReporting = (news_id) => {
  report.track("goto_news_1", { news_id });
};

/**
 * 点击官媒
 * @param share_plat 1微信、2微博、3Tap、 4B站、5QQ
 */
export const homeOnOfficialMediaClickReporting = (share_plat) => {
  report.track("official_media_1", {
    share_plat: share_plat,
  });
};

// 点击播放pv
export const homeOnPlayClickReporting = () => {
  report.track("PV_play_1");
};

// 点击地图
export const homeOnMapClickReporting = (map_id) => {
  report.track("look_map_1", { map_id });
};

// 点击角色
export const homeOnRoleClickReporting = (role_id) => {
  report.track("look_role_1", { role_id });
};

/**
 * 点击提交预约按钮
 */
export const homeOnBooking2ClickReporting = () => {
  report.track("booking2_click", {});
};

/**
 * 预约成功
 */
export const homeOnBookingSuccessReporting = () => {
  report.track("booking_finish", {});
};

/**
 * 播放视频
 */
export const homeOnVideoPlayReporting = () => {
  report.track("video_start", {});
};

/**
 * 播放视频结束
 */
export const homeOnVideoEndReporting = () => {
  report.track("video_end", {});
};
/**
 * 触发归环切换
 * @param share_plat 1\2\3
 */
export const homeOnLoopSwitchReporting = (share_plat) => {
  report.track("loop_start", { share_plat: share_plat });
};
